const prodConfig = {
  basename: '/',
  api: "https://fansandfellows-admin.hkdesigncentre.org/member/api",
  menu: {
    canLogout: true,
    canEditProfile: true,
    canAddCard: true,
    topSettingItems: [
      { url: 'contact-us', title: 'setting.contact-info' },
      { url: 'frequently-asked-question', title: 'setting.faq' }
    ],
    bottomSettingItems: [
      { url: 'terms-and-condition', title: 'setting.terms' },
      { url: 'privacy-policy', title: 'setting.privacy' },
      { url: 'copyright-policy', title: 'setting.copyright' }
    ]
  },
  firebase: {
    firebaseConfig: {
      apiKey: "AIzaSyAgul7-mcmup8PvX5LZ4RymNZA1hrjCJMw",
      authDomain: "hkdc-fansnfellows-web-prod.firebaseapp.com",
      projectId: "hkdc-fansnfellows-web-prod",
      storageBucket: "hkdc-fansnfellows-web-prod.firebasestorage.app",
      messagingSenderId: "147869263438",
      appId: "1:147869263438:web:b4f6c50ed4a007d72b851f",
      measurementId: "G-V89F7P3KB4"
    },
    vapidKey: 'BAAd2fO5ioWVQD7fDmIyoC9ZmMrOJB22P2J7BlHTY7FNRR2YL6a4CVJLFFdZrqyI52aqwPoYUVtPYd2ZvB9e0Ts'
  }
};

export default prodConfig;